import {Component, Input} from '@angular/core';
import {FileUploadStatus} from '../../model/file-upload-status';
import {FileUploadService} from '../../services/file-upload-service/file-upload.service';

@Component({
    selector: 'app-upload-container',
    templateUrl: './upload-container.component.html',
    styleUrls: ['./upload-container.component.scss', '../../../styles/form-input.scss'],
    standalone: false
})
export class UploadContainerComponent {

  @Input() fileUploadStatus: FileUploadStatus;
  @Input() callbackDeleteFileUploadStatus: (internalId: string) => void;
  @Input() retryFileUploadCallback: (fileUploadStatus: FileUploadStatus) => void;

  constructor(public fileUploadService: FileUploadService,) {
  }

  protected deleteFileUpload(id: string) {
    this.fileUploadService.deleteFileUpload(id).subscribe();
  }

  clearFileUpload(internalId: string) {
    this.callbackDeleteFileUploadStatus(internalId);
  }

  retryFileUpload() {
    this.retryFileUploadCallback(this.fileUploadStatus);
  }
}
